// Products API client (Phase 11).
import { request } from './api';

export const productsApi = {
    list: (params) => request('/products', { params }),
    get: (id) => request(`/products/${id}`),
    stats: (id, params) => request(`/products/${id}/stats`, { params }),
};
